import { render, staticRenderFns } from "./ColorScale.vue?vue&type=template&id=252fa604&scoped=true&"
import script from "./ColorScale.vue?vue&type=script&lang=ts&"
export * from "./ColorScale.vue?vue&type=script&lang=ts&"
import style0 from "./ColorScale.vue?vue&type=style&index=0&id=252fa604&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252fa604",
  null
  
)

export default component.exports